import React from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  IconButton,
  Typography,
} from "@mui/material";
import {
  Edit as EditIcon,
  Print as PrintIcon,
  SquareFoot as SquareFootIcon,
  ManageSearch as ManageSearchIcon,
  Bookmark as BookmarkIcon,
  FilterAlt as FilterAltIcon,
  AdsClick as AdsClickIcon,
  Directions as DirectionsIcon,
} from "@mui/icons-material";
import PinDropIcon from "@mui/icons-material/PinDrop";
import { openToolState } from "./toolRegistry";

const TOOL_BUTTONS = [
  { id: "draw", label: "Draw", Icon: EditIcon },
  { id: "measure", label: "Measure", Icon: SquareFootIcon },
  { id: "print", label: "Print", Icon: PrintIcon },
  { id: "query", label: "Query", Icon: ManageSearchIcon },
  { id: "bookmark", label: "Bookmark", Icon: BookmarkIcon },
  { id: "filter", label: "Filter", Icon: FilterAltIcon },
  { id: "assetSearch", label: "Near Me", Icon: PinDropIcon, pinStyle: true },
  { id: "select", label: "Select", Icon: AdsClickIcon },
  { id: "direction", label: "Directions", Icon: DirectionsIcon },
];

export default function ToolsFloatingBar({
  activeTools,
  setActiveTools,
  setActiveTab,
  setDrawerOpen,
}) {
  const openTool = (toolId) => {
    const { activeTools: nextTools, activeTab } = openToolState(
      activeTools,
      toolId,
    );
    setActiveTools(nextTools);
    setActiveTab(activeTab);
    setDrawerOpen(true);
  };

  return (
    <Paper
      square
      elevation={3}
      sx={{
        bgcolor: "white",
        borderBottom: "2px solid #e0e0e0",
        flexShrink: 0,
        zIndex: 1001,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#f8f9fa" }}>
        <Tabs
          value={0}
          sx={{
            minHeight: 28,
            "& .MuiTab-root": {
              minHeight: 28,
              textTransform: "none",
              fontSize: "11px",
              fontWeight: 500,
              py: 0.3,
            },
          }}
        >
          <Tab label="Tools" />
        </Tabs>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          px: 1,
          py: 0.5,
          bgcolor: "#e3f2fd",
        }}
      >
        {TOOL_BUTTONS.map(({ id, label, Icon, pinStyle }) => (
          <Box
            key={id}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.3,
            }}
          >
            <IconButton
              size="small"
              onClick={() => openTool(id)}
              sx={{
                bgcolor: "white",
                border: "1px solid #1976d2",
                width: 28,
                height: 28,
                "&:hover": { bgcolor: "#f5f5f5" },
                ...(pinStyle && {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  pt: 0.5,
                }),
              }}
            >
              {pinStyle ? (
                <>
                  <Icon sx={{ color: "#1976d2", fontSize: 16, lineHeight: 1 }} />
                  <Box
                    sx={{
                      width: 20,
                      height: 10,
                      mt: -0.8,
                      borderRadius: "50%",
                      background:
                        "radial-gradient(ellipse, rgba(25,118,210,0.6) 0%, rgba(25,118,210,0.1) 100%)",
                      border: "1px solid rgba(25,118,210,0.6)",
                    }}
                  />
                </>
              ) : (
                <Icon sx={{ color: "#1976d2", fontSize: 16 }} />
              )}
            </IconButton>
            <Typography variant="caption" sx={{ fontSize: "10px" }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
